import { useEffect } from 'react';
import { useLayout } from '@/contexts/LayoutContext';
import { useTheme } from '@/contexts/ThemeContext';
import { getLayout7ThemeStyle, WL7_THEME_KEYS } from './theme';

/** Injeta variáveis WL7 no :root quando o layout 7 está ativo (evita reset por `.layout-7` aninhado). */
export function Layout7ThemeSync() {
  const { currentLayout } = useLayout();
  const { colors } = useTheme();

  useEffect(() => {
    const root = document.documentElement;
    const isLayout7 = currentLayout === 'layout-7';

    if (!isLayout7) {
      WL7_THEME_KEYS.forEach((key) => root.style.removeProperty(key));
      return;
    }

    const style = getLayout7ThemeStyle(colors);
    Object.entries(style).forEach(([key, value]) => {
      if (typeof value === 'string') {
        root.style.setProperty(key, value);
      }
    });

    return () => {
      WL7_THEME_KEYS.forEach((key) => root.style.removeProperty(key));
    };
  }, [currentLayout, colors]);

  return null;
}
